<template>
  <div class="px-3">
    <div class="p-0 m-0 mt-4 main-title">總覽設定</div>
    <div style="margin-top: 2rem">
      <commonQueryInput
        :inputItems="multiInputItems"
        v-model:getValue="multiInputVal"
      ></commonQueryInput>
    </div>
    <template v-if="queryCheck">
      <div class="my-3">
        <div class="d-flex justify-content-between">
          <div>
            <label for="file-input" class="button homeMap-button" style=""
              >選擇底圖</label
            >
            <input
              type="file"
              id="file-input"
              class="d-none"
              @change="handleFileUpload"
              accept="image/png"
            />
          </div>
          <div>
            目前狀態:{{
              shape == "circle"
                ? "圓形"
                : shape == "rect"
                ? "矩形"
                : shape == "delete"
                ? "刪除"
                : "無"
            }}
            <button class="homeMap-button" @click="setShape('circle')">
              畫圓形
            </button>
            <button class="homeMap-button" @click="setShape('rect')">
              畫矩形
            </button>
            <button class="homeMap-button" @click="undoDrawing">復原</button>
            <button class="homeMap-button" @click="setShape('')">
              取消畫圖
            </button>
          </div>
          <div>
            <button class="homeMap-button" @click="setShape('delete')">
              刪除
            </button>
          </div>
          <div>
            <button class="homeMap-button" @click="modalShow = true">
              清空
            </button>
          </div>
        </div>
      </div>
      <div
        class="canvas-container mb-3"
        @mousedown="startDrawing"
        @mousemove="resizeShape"
        @mouseup="stopDrawing"
      >
        <div class="image-overlay" :style="{ cursor: shapeCursor }"></div>
        <img v-if="imageUrl" ref="imageRef" :src="imageUrl" alt="上傳的圖片" />
        <div
          v-for="(element, index) in elements"
          :key="index"
          :style="element.style"
          :class="{ focus: select == index }"
          @click="clickArea(index)"
        ></div>
      </div>
      <div v-if="elements.length > 0" style="overflow: auto; max-height: 320px">
        <h4>已繪製的形狀</h4>
        <div class="row justify-content-start mx-0 pb-3 px-0">
          <template v-for="(element, index) in elements" :key="index">
            <div
              v-if="element.style != null"
              class="mt-2 ml-0 justify-content-center col-sm-6 col-md-4 col-lg-3 col-xl-2 col-6 ps-0"
            >
              <div class="input-group flex-nowrap">
                <span class="input-group-text homeMap-span">
                  {{ index + 1 }}.</span
                >
                <input
                  name="device-input"
                  type="text"
                  ref="inputs"
                  class="form-control"
                  v-model="elements[index]['id']"
                  @focus="select = index"
                  @blur="select = null"
                  placeholder="device id"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="text-end">
        <button class="homeMap-button" @click="sendData">送出</button>
      </div>
    </template>
  </div>

  <commonModal :modalShow="modalShow">
    <template v-slot:modalheader>
      <button type="button" class="close" @click="modalShow = false">×</button>
    </template>
    <template v-slot:default>
      <div>
        <p>確定要清空所有已設置區塊？</p>
      </div>
      <div>
        <button
          type="button"
          class="btn p-0"
          style="
            color: var(--main-font-color);
            background-color: var(--main-bg-color);
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
            margin-right: 40px;
          "
          @click="modalShow = false"
        >
          取消
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: var(--main-font-color);
            background-color: var(--main-bg-color);
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="(modalShow = false), clearDrawing()"
        >
          確認
        </button>
      </div>
    </template>
  </commonModal>
</template>

<script>
import { ref, reactive, computed, nextTick, watch, inject } from "vue";
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonModal from "@/components/commonModal.vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    commonModal,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const axiosFileResult = computed(
      () => store.getters["commonAxios/get_axiosFileResult"]
    );

    //dispatch
    const methods = {
      axiosActionFile: async (payload) => {
        await store.dispatch("commonAxios/axiosActionFile", payload);
      },
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");

    const areaOptions = computed(() => {
      let area = [];
      if (sideBar.value.home != undefined) {
        let homeChildren = sideBar.value.home.children;
        let pageName = Object.keys(homeChildren);
        pageName.forEach((data) => {
          area.push({
            value: data,
            text: homeChildren[data].name,
          });
        });
      }
      return area;
    });
    const areaSelect = ref("");

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "area",
        label: "場域",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇場域 --",
        options: areaOptions,
      },
    ]);

    const queryCheck = ref(false);
    const device_data = ref({});
    const imageName = ref("");
    const imageUrl = ref("");
    const shape = ref("");
    const isDrawing = ref(false);
    const startCoordinates = ref({ x: 0, y: 0 });
    const endCoordinates = ref({ x: 0, y: 0 });
    const imageRef = ref(null);
    const elements = reactive([]);
    const shapeCursor = computed(() => {
      return shape.value ? "crosshair" : "auto";
    });
    const imageSize = ref({ width: 0, height: 0 });
    const imageElementsSize = reactive([]);
    const select = ref(null); // 選擇的區塊
    const inputs = ref([]); // 暫存輸入框
    const modalShow = ref(false);
    const selectedFile = ref(null);

    // 上傳圖片的事件處理方法
    const handleFileUpload = (event) => {
      console.log(event);
      selectedFile.value = event.target.files[0];
      console.log(selectedFile.value);
      if (selectedFile.value === undefined) {
        selectedFile.value = null;
        return;
      }
      imageUrl.value = URL.createObjectURL(selectedFile.value);
      shape.value = "";
      resetDrawing();
      imageRef.value = null;
      imageSize.value = { width: 0, height: 0 };

      // 延遲更新點座標，以便適應圖片大小
      setTimeout(() => {
        resizeMap();
      }, 500);
    };

    // 設定繪製形狀的方法
    const setShape = (selectedShape) => {
      shape.value = selectedShape;
    };

    // 點擊區塊的方法
    const clickArea = (index) => {
      if (shape.value == "delete") {
        // 移除區塊
        elements.splice(index, 1);
        imageElementsSize.splice(index, 1);
      } else {
        // focus區塊對應的輸入框
        nextTick(() => {
          const inputElement = inputs.value[index];
          if (inputElement) {
            inputElement.focus();
          }
        });
        select.value = index;
      }
    };

    // 開始繪製的方法
    const startDrawing = (event) => {
      if (shape.value && isMouseOverImage(event)) {
        isDrawing.value = true;
        startCoordinates.value = { x: event.clientX, y: event.clientY };
        endCoordinates.value = { x: event.clientX, y: event.clientY };
      }
    };

    // 調整繪製形狀大小的方法
    const resizeShape = (event) => {
      if (isDrawing.value) {
        endCoordinates.value = { x: event.clientX, y: event.clientY };
        if (hasMoved()) {
          createOrUpdateDrawingElement();
        }
      }
    };

    // 調整圖片大小位置的方法
    const resizeMap = () => {
      const image = imageRef.value;
      if (image && elements.length > 0) {
        const nowWidth = image.clientWidth;
        const nowHeight = image.clientHeight;
        imageElementsSize.forEach((data, index) => {
          const newWidth = nowWidth / data.mapWidth;
          const newHeight = nowHeight / data.mapHeight;
          elements[index].style.top = `${data.top * newHeight}px`; // 調整元素的 top 屬性
          elements[index].style.left = `${data.left * newWidth}px`; // 調整元素的 left 屬性
          elements[index].style.width = `${data.width * newWidth}px`; // 調整元素的 width 屬性
          elements[index].style.height = `${data.height * newHeight}px`; // 調整元素的 height 屬性
        });
      }
    };

    // 停止繪製的方法
    const stopDrawing = () => {
      if (isDrawing.value) {
        isDrawing.value = false;
        if (hasMoved()) {
          createOrUpdateDrawingElement();
          const { top, left, width, height } =
            elements[elements.length - 1].style;
          const image = imageRef.value;
          if (image) {
            imageSize.value.width = image.clientWidth;
            imageSize.value.height = image.clientHeight;
          }
          const mapWidth = imageSize.value.width;
          const mapHeight = imageSize.value.height;
          imageElementsSize.push({
            mapWidth,
            mapHeight,
            top: Number(top.split("px")[0]), // 獲取 top 屬性值並轉換為數字
            left: Number(left.split("px")[0]), // 獲取 left 屬性值並轉換為數字
            width: Number(width.split("px")[0]), // 獲取 width 屬性值並轉換為數字
            height: Number(height.split("px")[0]), // 獲取 height 屬性值並轉換為數字
            shape: shape.value,
          });
          clickArea(elements.length - 1); // 鎖定輸入框
          elements.push({});
          resizeMap();
        }
      }
    };

    // 創建或更新繪製元素的方法
    const createOrUpdateDrawingElement = () => {
      if (elements.length === 0) {
        createDrawingElement();
      } else {
        updateDrawingElement();
      }
    };

    // 創建繪製元素的方法
    const createDrawingElement = () => {
      const image = imageRef.value;
      if (image) {
        const { left, top } = image.getBoundingClientRect();
        const drawingLeft =
          Math.min(startCoordinates.value.x, endCoordinates.value.x) - left;
        const drawingTop =
          Math.min(startCoordinates.value.y, endCoordinates.value.y) - top;

        const newElement = {
          style: {
            position: "absolute",
            top: `${drawingTop}px`,
            left: `${drawingLeft}px`,
            width: "0",
            height: "0",
            // border: "2px solid blue",
            "background-color": "lightblue",
            opacity: 0.5,
            borderRadius: shape.value === "circle" ? "50%" : "0", // 設定圓形或正方形的邊框半徑
          },
        };

        elements.push(newElement);
      }
    };

    // 更新繪製元素的方法
    const updateDrawingElement = () => {
      const image = imageRef.value;
      if (image && elements.length > 0) {
        const { left, top } = image.getBoundingClientRect();
        const drawingLeft =
          Math.min(startCoordinates.value.x, endCoordinates.value.x) - left;
        const drawingTop =
          Math.min(startCoordinates.value.y, endCoordinates.value.y) - top;
        const width = Math.abs(
          endCoordinates.value.x - startCoordinates.value.x
        );
        const height = Math.abs(
          endCoordinates.value.y - startCoordinates.value.y
        );

        const updatedElement = {
          ...elements[elements.length - 1],
          style: {
            position: "absolute",
            top: `${drawingTop}px`,
            left: `${drawingLeft}px`,
            width: `${width}px`,
            height: `${height}px`,
            // border: "2px solid blue",
            "background-color": "lightblue",
            opacity: 0.5,
            borderRadius: shape.value === "circle" ? "50%" : "0", // 設定圓形或正方形的邊框半徑
          },
        };

        elements.splice(elements.length - 1, 1, updatedElement);
      }
    };

    // 重置繪製狀態的方法
    const resetDrawing = () => {
      isDrawing.value = false;
    };

    // 檢查滑鼠是否在圖片上的方法
    const isMouseOverImage = (event) => {
      const image = imageRef.value;
      if (image) {
        const { left, top, width, height } = image.getBoundingClientRect();
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        return (
          mouseX >= left &&
          mouseX <= left + width &&
          mouseY >= top &&
          mouseY <= top + height
        );
      }
      return false;
    };

    // 檢查是否有移動滑鼠的方法
    const hasMoved = () => {
      const startX = startCoordinates.value.x;
      const startY = startCoordinates.value.y;
      const endX = endCoordinates.value.x;
      const endY = endCoordinates.value.y;
      return startX !== endX || startY !== endY;
    };

    // 復原繪製的方法
    const undoDrawing = () => {
      if (elements.length > 0) {
        elements.splice(elements.length - 2, 1);
        imageElementsSize.splice(imageElementsSize.length - 1, 1);
      }
      if (elements.length == 1 && elements[0].style == undefined) {
        elements.splice(elements.length - 1, 1);
      }

      // 延遲更新點座標，以便適應圖片大小
      setTimeout(() => {
        resizeMap();
      }, 500);
    };

    // 清空繪製的方法
    const clearDrawing = () => {
      if (elements.length > 0) {
        elements.splice(0);
        imageElementsSize.splice(0);
      }
    };

    window.addEventListener("resize", function () {
      resizeMap();
    });

    // 清除場域圖資料
    const clearMapData = () => {
      imageName.value = "";
      imageUrl.value = "";
      shape.value = "";
      resetDrawing();
      imageRef.value = null;
      imageSize.value = { width: 0, height: 0 };

      elements.splice(0);
      imageElementsSize.splice(0);
    };

    // 更新場域圖上的資料
    const updateMapData = (resultData) => {
      if (resultData.image_name == "") {
        resultData.image_name = areaSelect.value + ".png";
        console.log(resultData.image_name);
      }
      imageName.value = resultData.image_name;
      let area = imageName.value.split(".")[0];
      imageUrl.value = "/static/image/" + imageName.value;
      selectedFile.value = null;

      resultData.device_data.forEach((data) => {
        elements.push({
          style: {
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "0px",
            height: "0px",
            // border: "2px solid blue",
            "background-color": "lightblue",
            opacity: 0.5,
            borderRadius: data.shape === "circle" ? "50%" : "0", // 設定圓形或正方形的邊框半徑
          },
          id: data.deviceName,
        });
        let newObj = {
          mapWidth: data.image_weight,
          mapHeight: data.image_height,
          top: data[area].top, // 獲取 top 屬性值並轉換為數字
          left: data[area].left, // 獲取 left 屬性值並轉換為數字
          width: data[area].width, // 獲取 width 屬性值並轉換為數字
          height: data[area].height, // 獲取 height 屬性值並轉換為數字
          shape: data.shape,
        };
        imageElementsSize.push(newObj);
        device_data.value[data.deviceName] = newObj;
      });
      elements.push({});
      // 延遲更新點座標，以便適應圖片大小
      setTimeout(() => {
        resizeMap();
      }, 500);
    };

    // watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        clearMapData();
        queryCheck.value = false;
        device_data.value = {};
        areaSelect.value = newValue["area"];
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "QueryDeviceArea";
        params["area"] = areaSelect.value;

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            queryCheck.value = true;
            let queryTableData = result.QueryTableData;
            updateMapData(queryTableData);
          } else {
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    // 送出按鈕
    const sendData = () => {
      methods.triggerLoadingBar();

      //確認ID有沒有重複
      let updateData = [];
      let addData = [];
      let deviceIdArray = [];
      for (let i = 0; i < imageElementsSize.length; i++) {
        let thisDeviceId = elements[i].id;
        deviceIdArray.push(thisDeviceId);
        if (thisDeviceId == "" || thisDeviceId == undefined) {
          methods.setTimeoutAlert("尚有ID未填寫");
          methods.triggerLoadingBar();
          return;
        }
        let data = imageElementsSize[i];
        console.log(device_data.value[thisDeviceId]);

        if (device_data.value[thisDeviceId] != undefined) {
          // 原本ID存在
          if (
            // 原本ID存在，內容不一樣，做更新
            data.mapWidth != device_data.value[thisDeviceId].mapWidth ||
            data.mapHeight != device_data.value[thisDeviceId].mapHeight ||
            data.top != device_data.value[thisDeviceId].top ||
            data.left != device_data.value[thisDeviceId].left ||
            data.width != device_data.value[thisDeviceId].width ||
            data.height != device_data.value[thisDeviceId].height ||
            data.shape != device_data.value[thisDeviceId].shape
          ) {
            console.log(thisDeviceId);
            updateData.push({
              old_image_name: imageName.value,
              old_device_name: thisDeviceId,
              image_weight: data.mapWidth,
              image_height: data.mapHeight,
              exhibit_shape: data.shape,
              position: JSON.stringify({
                top: data.top,
                left: data.left,
                width: data.width,
                height: data.height,
              }),
            });
            console.log(updateData);
          }
        } else {
          // ID不存在，做新增
          addData.push({
            image_name: imageName.value,
            device_name: thisDeviceId,
            image_weight: data.mapWidth,
            image_height: data.mapHeight,
            exhibit_shape: data.shape,
            position: JSON.stringify({
              top: data.top,
              left: data.left,
              width: data.width,
              height: data.height,
            }),
          });
        }
      }
      let deleteData = [];
      Object.keys(device_data.value).forEach((data) => {
        if (!deviceIdArray.includes(data)) {
          deleteData.push({
            image_name: imageName.value,
            device_name: data,
          });
        }
      });

      if (
        updateData.length == 0 &&
        addData.length == 0 &&
        deleteData.length == 0 &&
        selectedFile.value == null
      ) {
        methods.setTimeoutAlert(`無異動`);
        methods.triggerLoadingBar();
        return;
      }

      queryCheck.value = false;
      console.log(multiInputVal.value);

      if (selectedFile.value != null) {
        uploadImage(addData, updateData, deleteData);
      } else if (
        updateData.length != 0 ||
        addData.length != 0 ||
        deleteData.length != 0
      ) {
        changeImageDevice(addData, updateData, deleteData);
      }
    };

    const uploadImage = (...changeData) => {
      console.log(imageName.value);
      const formData = new FormData();
      formData.append("file", selectedFile.value);
      formData.append("fileName", imageName.value.split(".")[0]);
      methods.axiosActionFile(formData).then(() => {
        let result = axiosFileResult.value;
        console.log(result);
        let response = result.Response;
        if (response != "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("圖片上傳失敗");
        }
        changeImageDevice(...changeData);
      });
    };

    const changeImageDevice = (addData, updateData, deleteData) => {
      if (
        updateData.length == 0 &&
        addData.length == 0 &&
        deleteData.length == 0
      ) {
        methods.triggerLoadingBar();
        methods.setTimeoutAlert("完成");
        return;
      }
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateDeviceArea";
      params["area"] = imageName.value.split(".")[0];
      params["addData"] = addData;
      params["updateData"] = updateData;
      params["deleteData"] = deleteData;

      methods.axiosAction(params).then(() => {
        clearMapData();
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          updateMapData(queryTableData);
          methods.setTimeoutAlert("完成");
        } else {
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };

    return {
      multiInputVal,
      multiInputItems,
      queryCheck,
      imageUrl,
      shape,
      imageRef,
      elements,
      shapeCursor,
      select,
      inputs,
      handleFileUpload,
      setShape,
      clickArea,
      startDrawing,
      resizeShape,
      stopDrawing,
      undoDrawing,
      clearDrawing,
      sendData,
      modalShow,
    };
  },
};
</script>

<style>
.canvas-container {
  position: relative;
  display: inline-block;
  /* min-width: 800px; */
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: crosshair;
  user-select: none;
}

.canvas-container img {
  max-width: 100%;
  height: auto;
  max-height: 600px;
}

.focus {
  /* border-color: brown !important; */
  background-color: brown !important;
}

.homeMap-button {
  display: inline-block;
  padding: 1px 6px;
  text-align: center;
  text-decoration: none;
  border: 2px outset transparent;
  background-color: var(--main-bg-color);
  border-radius: 5px;
  margin-left: 16px;
  cursor: pointer;
  font-size: 16px;
  color: #eefbf0;
}
div > .homeMap-button:first-child {
  margin-left: 0;
}

.homeMap-span {
  color: #eefbf0;
  background-color: var(--main-bg-color);
}
</style>
